<template>
  <div>
    <b-modal id="cart-modal" hide-footer content-class="cart-modal">
      <div>
        <div class="text-center">
          <h3 class="modal-title">Your Cart</h3>
          <p class="product-numbers" v-if="products.length > 0">{{ products.length }} Products</p>
        </div>
        <div class="cart-items" v-if="products.length > 0">
          <div
            class="item d-flex align-items-center justify-content-between"
            v-for="(product, index) in products"
            :key="product.id"
          >
            <div class="item-info d-flex align-items-center">
              <div
                class="items-image bg-cover"
                :style="{'background-image': `url('${product.images[0]}')`}"
              ></div>
              <div class="text">
                <p class="item-name">{{ product.name }}</p>
                <p class="item-price">{{ product.price | currency}}</p>
              </div>
            </div>

            <div class="item-info m-auto">
              <div class="text">
                <p class="item-name invisible">{{ product.name }}</p>
                <p class="item-price">{{ product.price * product.quantity | currency}}</p>
              </div>
            </div>
            <div class="quantity rounded d-inline-block d-md-flex justify-content-between ml-auto">
              <div>
                <i
                  class="fas fa-angle-left decrease-quantity"
                  @click="decreaseQuantity(product.id)"
                ></i>
                <input
                  type="number"
                  name="quantity"
                  :value="product.quantity"
                  class="quantity-input"
                  min="1"
                />
                <i
                  class="fas fa-angle-right increase-quantity"
                  @click="increaseQuantity(product.id)"
                ></i>
              </div>
            </div>
            <span class="remove-item" @click="deleteCartItem(index)">
              <i class="fas fa-times"></i>
            </span>
          </div>
        </div>
        <div v-else class="text-center my-3">
          <h6>Your Cart is empty</h6>
        </div>

        <div class="d-flex border-top">
          <div class="mr-auto"></div>

          <button class="btn main-btn mt-3 ml-2" @click="hideModal">Continue Shooping</button>
          <button class="btn main-btn mt-3 ml-2" @click="goToCheckout" v-if="products.length > 0">Checkout</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "cartModal",
  computed: {
    products() {
      return this.$store.getters["cartModule/getCartItems"];
    }
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("cart-modal");
    },
    goToCheckout() {
      this.hideModal();
      this.$router.push("/checkout");
    },
    deleteCartItem(productId) {
      this.$store.commit("cartModule/deleteCartItem", productId);
    },
    decreaseQuantity(productId) {
      this.$store.commit("cartModule/decreaseQuantity", productId);
    },
    increaseQuantity(productId) {
      this.$store.commit("cartModule/increaseQuantity", productId);
    }
  }
};
</script>
